<div class="modal active facility">
  <div class="modal__container">
    <div class="fields">
      <h2 class="title">Directory Settings</h2>
      <div class="close" (click)="cancelConfiguration()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  name="ngFacilityForm" #ngForm="ngForm" id="FacilityForm" class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Directory Parameters</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Working Path</label>
                  <input
                    maxlength="10"
                    [(ngModel)]="configurationController.currentConfiguration.directories.workingPath"
                    (change)='updateField("workingPath",$event.target.value)'
                    type="text"
                    name="workingPath"
                    id="workingPath"
                    class="workingPathInput"
                  />
                  <span>[NM]</span>

                </div>
              </div>
              <div>
                <label for="">3D Local Cache Path</label>
                <input
                  maxlength="10"
                  [(ngModel)]="configurationController.currentConfiguration.directories.localCachePath_3D"
                  (change)='updateField("localCachePath_3D", $event.target.value)'
                  type="text"
                  name="3dLocalCachePath"
                  id="3dLocalCachePath"
                  class="3dLocalCachePathInput"
                />
              </div>

            </div>
            <div>
              <label for="">NavAid Database</label>
                <input
                  maxlength="10"
                  [(ngModel)]="configurationController.currentConfiguration.directories.navAidDatabase"
                  (change)='updateField("navAidDatabase",$event.target.value)'
                  type="text"
                  name="navAidDatabase"
                  id="navAidDatabase"
                  class="navAidDatabaseInput"
                />
              </div>
            </div>



          <div class="fields__btn">
            <button type="submit" [ngClass]="ngForm.form.valid ? 'blue' : 'gray'" (click)="saveConfiguration()" [disabled]="!ngForm.form.valid">
              Save
            </button>
            <button class="gray" (click)="cancelConfiguration()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
